import { ANY_VALUE_NUMBER_NUMERIC } from '../../../NonReact/common/DefaultValues'
import {
    TELEPHONY_SYSTEM_TYPE_BROADSOFT_BROADWORKS,
    TELEPHONY_SYSTEM_TYPE_MS_TEAMS,
    TELEPHONY_SYSTEM_TYPE_SIMULATOR
} from '../../../NonReact/constants/TelephonyServerTypes'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { SelectOptions } from '../../Common/Components/Selects'
import { CallMovementFiltering as CallMovementFilteringLanguage } from '../../../../i18n'

export const getSegmentSelectOptions = (language: CLanguageHandler, telsysType?: number): SelectOptions<number> => {
    const isAfterFilteringOptionsIncluded: boolean =
        telsysType === TELEPHONY_SYSTEM_TYPE_BROADSOFT_BROADWORKS || telsysType === TELEPHONY_SYSTEM_TYPE_SIMULATOR

    return [
        {
            value: ANY_VALUE_NUMBER_NUMERIC,
            label: language.get(CallMovementFilteringLanguage.CallsegmentnumberAnyOptionLabel)
        },
        {
            value: 1,
            label: language.get(CallMovementFilteringLanguage.CallsegmentnumberFirstOptionLabel)
        },
        ...(isAfterFilteringOptionsIncluded
            ? [
                  {
                      value: -3,
                      label: language.get(CallMovementFilteringLanguage.CallsegmentnumberFirstAfterFilteringOptionLabel)
                  }
              ]
            : []),
        {
            value: 2,
            label: language.get(CallMovementFilteringLanguage.Callsegmentnumber2OptionLabel)
        },
        {
            value: 3,
            label: language.get(CallMovementFilteringLanguage.Callsegmentnumber3OptionLabel)
        },
        {
            value: 4,
            label: language.get(CallMovementFilteringLanguage.Callsegmentnumber4OptionLabel)
        },
        {
            value: 5,
            label: language.get(CallMovementFilteringLanguage.Callsegmentnumber5OptionLabel)
        },
        {
            value: -106,
            label: language.get(CallMovementFilteringLanguage.Callsegmentnumber6plusOptionLabel)
        },
        {
            value: -2,
            label: language.get(CallMovementFilteringLanguage.CallsegmentnumberLastOptionLabel)
        },
        ...(isAfterFilteringOptionsIncluded
            ? [
                  {
                      value: -4,
                      label: language.get(CallMovementFilteringLanguage.CallsegmentnumberLastAfterFilteringOptionLabel)
                  }
              ]
            : [])
    ]
}

export const getCallSegmentStartReasonOptions = (
    language: CLanguageHandler,
    telsysType?: number
): SelectOptions<number> => [
    {
        value: ANY_VALUE_NUMBER_NUMERIC,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonAnyOptionLabel)
    },
    {
        value: 0,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonDivertedtoOptionLabel)
    },
    {
        value: 1,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonOverflowedinOptionLabel)
    },
    ...(telsysType === TELEPHONY_SYSTEM_TYPE_MS_TEAMS
        ? []
        : [
              {
                  value: 2,
                  label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonAdvancedtoOptionLabel)
              }
          ]),
    {
        value: 3,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonTransferredtoOptionLabel)
    },
    {
        value: 4,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonConferencedtoOptionLabel)
    },
    {
        value: 5,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonConferencedegenOptionLabel)
    },
    {
        value: 6,
        label: language.get(CallMovementFilteringLanguage.CallsegmentstartreasonEscapedtoOptionLabel)
    },
    {
        value: 7,
        label: language.get(CallMovementFilteringLanguage.CallsegmentStartEndReasonSupervisorTransferOptionLabel)
    }
]

export const getCallSegmentEndReasonOptions = (
    language: CLanguageHandler,
    telsysType?: number
): SelectOptions<number> => [
    {
        value: ANY_VALUE_NUMBER_NUMERIC,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonAnyOptionLabel)
    },
    {
        value: 0,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonDivertedfromOptionLabel)
    },
    {
        value: 1,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonOverflowedoffOptionLabel)
    },
    ...(telsysType === TELEPHONY_SYSTEM_TYPE_MS_TEAMS
        ? []
        : [
              {
                  value: 2,
                  label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonAdvancedfromOptionLabel)
              }
          ]),
    {
        value: 3,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonTransferredfromOptionLabel)
    },
    {
        value: 4,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonConferencedfromOptionLabel)
    },
    {
        value: 5,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonConferencedegenOptionLabel)
    },
    {
        value: 6,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonEscapedfromOptionLabel)
    },
    {
        value: 34,
        label: language.get(CallMovementFilteringLanguage.CallsegmentStartEndReasonSupervisorTransferOptionLabel)
    },
    {
        value: 10,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonConsultationtrtoOptionLabel)
    },
    {
        value: 20,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonMovedtoconferenceOptionLabel)
    },
    {
        value: 21,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonMovedtoparkOptionLabel)
    },
    {
        value: 22,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonMovedtovoicemailOptionLabel)
    },
    {
        value: 11,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonEndedonholdonlyOptionLabel)
    },
    {
        value: 111,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonEndedonholdexclOptionLabel)
    },
    {
        value: 23,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonUnmonitoreddestOptionLabel)
    },
    {
        value: 24,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonUnknowndestOptionLabel)
    },
    {
        value: 28,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonAllunrslvddestonlyOptionLabel)
    },
    {
        value: 128,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonAllunrslvddestexclOptionLabel)
    },
    {
        value: 30,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonModellingerrorsonlyOptionLabel)
    },
    {
        value: 130,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonModellingerrorsexclOptionLabel)
    },
    {
        value: 31,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonApplicationendedOptionLabel)
    },
    {
        value: 32,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonDevicedeletedOptionLabel)
    },
    {
        value: 33,
        label: language.get(CallMovementFilteringLanguage.CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel)
    }
]
